/* eslint-env browser */

/**
 * Hamburger menu implementation
 */

(function () {
    var dropdownToggle = $('.dropdown-toggle');
    var dropdownMenu = $('.dropdown-menu');

    var toggleMenu = function () {
        $(dropdownMenu).toggle();
    }

    $(dropdownToggle).click(toggleMenu);
})();
